import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import useNavigationLogger from '../router/UseNavigationLogger'

const MobileLayout: React.FC = () => {
    useNavigationLogger()

    return (
        <Box className='Layout'>
            <Outlet />
        </Box>
    )
}

export default MobileLayout
